const blogData = [
  {
    id: 1,
    slug: "top-seo-strategies-2025",
    title: "Top SEO Strategies to Dominate Google in 2025",
    excerpt: "Discover the latest SEO techniques that will help your website rank higher in search results and drive organic traffic.",
    content: "Full blog content here...",
    image: "img/blog/blog-1.jpg",
    author: "SDtech Team",
    date: "Jan 15, 2025",
    category: "SEO",
    tags: ["SEO", "Digital Marketing", "Google"],
    comments: 12,
  },
  {
    id: 2,
    slug: "react-vs-nextjs-which-is-better",
    title: "React vs Next.js — Which One Should You Choose in 2025?",
    excerpt: "A detailed comparison of React and Next.js to help you make the right choice for your next web development project.",
    content: "Full blog content here...",
    image: "img/blog/blog-2.jpg",
    author: "SDtech Team",
    date: "Jan 10, 2025",
    category: "Web Development",
    tags: ["React", "Next.js", "JavaScript"],
    comments: 8,
  },
  {
    id: 3,
    slug: "mobile-app-development-guide",
    title: "Complete Guide to Mobile App Development in 2025",
    excerpt: "Everything you need to know about building a successful mobile app — from idea to launch on App Store and Play Store.",
    content: "Full blog content here...",
    image: "img/blog/blog-3.jpg",
    author: "SDtech Team",
    date: "Jan 5, 2025",
    category: "Mobile Apps",
    tags: ["Flutter", "React Native", "Mobile"],
    comments: 15,
  },
  {
    id: 4,
    slug: "social-media-marketing-tips",
    title: "10 Social Media Marketing Tips for Small Businesses",
    excerpt: "Practical social media marketing strategies that small businesses can implement today to grow their brand and reach.",
    content: "Full blog content here...",
    image: "img/blog/blog-4.jpg",
    author: "SDtech Team",
    date: "Dec 28, 2024",
    category: "Marketing",
    tags: ["Social Media", "Marketing", "Business Growth"],
    comments: 6,
  },
];

export default blogData;